"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_helmet_1 = require("react-helmet");

var router_1 = require("@reach/router");

var library_airtable_cms_text_1 = require("@talus-analytics/library.airtable.cms-text");

var library_airtable_cms_image_1 = require("@talus-analytics/library.airtable.cms-image");

var _1 = require("./");

var SEO = function SEO(_ref) {
  var title = _ref.title,
      description = _ref.description,
      imageUrl = _ref.imageUrl,
      article = _ref.article,
      _ref$noEmitError = _ref.noEmitError,
      noEmitError = _ref$noEmitError === void 0 ? false : _ref$noEmitError;

  var _a;

  var _ref2 = (0, router_1.useLocation)(),
      pathname = _ref2.pathname;

  var siteMetadataContext = (0, react_1.useContext)(_1.SiteMetadataContext); // check for context provider

  if (siteMetadataContext === null) {
    throw new Error('No data found in SiteMetadataContext. Does a parent component ' + '(most likely <Layout /> or <Providers />) include the ' + '<SiteMetadataProvider /> component, and is that component ' + 'passed a result from the useSiteMetadata() hook?');
  } // extract data from context


  var data = siteMetadataContext.data; // throw error if no site metadata table exists

  if (Object.keys(data).length === 0 || data.nodes.length === 0) {
    throw new Error("Problem querying \"Site metadata\" table" + "from Airtable. Does a table titled \"Site metadata\" exist?");
  }

  var defaults = {
    title: (0, library_airtable_cms_text_1.getCMSText)(data, 'Default title', noEmitError),
    titleTemplate: (0, library_airtable_cms_text_1.getCMSText)(data, 'Title template', noEmitError),
    description: (0, library_airtable_cms_text_1.getCMSText)(data, 'Default description', noEmitError),
    // image might be undefined and that's okay,
    // image meta tags simply won't render if that's the case
    // (getCMSImage is suppressing errors)
    image: (_a = (0, library_airtable_cms_image_1.getCMSImage)(data, 'Default image', true)) === null || _a === void 0 ? void 0 : _a.url,
    siteUrl: (0, library_airtable_cms_text_1.getCMSText)(data, 'Site URL', noEmitError),
    // twitter username might be undefined and that's okay,
    // that meta tag simply won't render if that's the case
    // (getCMSText is suppressing errors)
    twitterUsername: (0, library_airtable_cms_text_1.getCMSText)(data, 'Twitter username', true)
  };
  var seo = {
    // title could intentionally be undefined, in which case
    // default title will be applied
    title: title,
    description: description || defaults.description,
    image: imageUrl || defaults.image,
    url: "".concat(defaults.siteUrl).concat(pathname)
  };
  return react_1.default.createElement(react_helmet_1.Helmet
  /* If title is defined, title template will kick in */

  /* Otherwise, default title is applied */
  , {
    /* If title is defined, title template will kick in */

    /* Otherwise, default title is applied */
    title: seo.title,
    titleTemplate: defaults.titleTemplate,
    defaultTitle: defaults.title
  }, react_1.default.createElement("meta", {
    name: "description",
    content: seo.description
  }), seo.image && react_1.default.createElement("meta", {
    name: "image",
    content: seo.image
  }), seo.url && react_1.default.createElement("meta", {
    property: "og:url",
    content: seo.url
  }), article && react_1.default.createElement("meta", {
    property: "og:type",
    content: "article"
  }), (seo.title || defaults.title) && react_1.default.createElement("meta", {
    property: "og:title",
    content: seo.title || defaults.title
  }), seo.description && react_1.default.createElement("meta", {
    property: "og:description",
    content: seo.description
  }), seo.image && react_1.default.createElement("meta", {
    property: "og:image",
    content: seo.image
  }), react_1.default.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), defaults.twitterUsername && react_1.default.createElement("meta", {
    name: "twitter:creator",
    content: defaults.twitterUsername
  }), seo.title && react_1.default.createElement("meta", {
    name: "twitter:title",
    content: seo.title
  }), seo.description && react_1.default.createElement("meta", {
    name: "twitter:description",
    content: seo.description
  }), seo.image && react_1.default.createElement("meta", {
    name: "twitter:image",
    content: seo.image
  }));
};

exports.default = SEO;